import { TICKETS } from "./tickets";
import { PLANNING } from "./planning";
import { HIGHLIGHTS } from "./highlights";
import { GUIDES } from "./guides";
import { TOP_FAQS } from "./site";

// Flat searchable index across the whole site.
export const SEARCH_INDEX = [
  ...TICKETS.map((t) => ({
    type: "Ticket",
    title: t.name,
    description: t.tagline,
    to: `/tickets/${t.slug}`,
    keywords: [t.name, t.shortName, t.tagline, ...(t.highlights || [])].join(" ").toLowerCase(),
  })),
  ...PLANNING.map((p) => ({
    type: "Plan Your Visit",
    title: p.title,
    description: p.subtitle,
    to: `/plan/${p.slug}`,
    keywords: [p.title, p.subtitle, p.intro].join(" ").toLowerCase(),
  })),
  ...HIGHLIGHTS.map((h) => ({
    type: "Highlight",
    title: h.title,
    description: h.subtitle,
    to: `/highlights/${h.slug}`,
    keywords: [h.title, h.subtitle, h.intro].join(" ").toLowerCase(),
  })),
  ...GUIDES.map((g) => ({
    type: "Guide",
    title: g.title,
    description: g.subtitle,
    to: `/guides/${g.slug}`,
    keywords: [g.title, g.subtitle, g.intro, g.category].join(" ").toLowerCase(),
  })),
  ...TOP_FAQS.map((f) => ({
    type: "FAQ",
    title: f.q,
    description: f.a.slice(0, 120) + "…",
    to: "/plan/faqs",
    keywords: [f.q, f.a].join(" ").toLowerCase(),
  })),
];

export const searchSite = (query) => {
  const q = query.trim().toLowerCase();
  if (!q) return [];
  const terms = q.split(/\s+/);
  return SEARCH_INDEX.map((item) => {
    let score = 0;
    terms.forEach((term) => {
      if (item.title.toLowerCase().includes(term)) score += 3;
      if (item.keywords.includes(term)) score += 1;
    });
    return { item, score };
  })
    .filter((r) => r.score > 0)
    .sort((a, b) => b.score - a.score)
    .slice(0, 12)
    .map((r) => r.item);
};
